import { render, staticRenderFns } from "./TestbankHistoryUser.vue?vue&type=template&id=40dba5ae&"
import script from "./TestbankHistoryUser.vue?vue&type=script&lang=js&"
export * from "./TestbankHistoryUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40dba5ae')) {
      api.createRecord('40dba5ae', component.options)
    } else {
      api.reload('40dba5ae', component.options)
    }
    module.hot.accept("./TestbankHistoryUser.vue?vue&type=template&id=40dba5ae&", function () {
      api.rerender('40dba5ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Testbank/History/TestbankHistoryUser.vue"
export default component.exports